import React, { useState, useRef, useEffect } from 'react'

// import {
//   FaInstagram,
//   FaFacebookF,
//   FaLinkedinIn
// } from "react-icons/fa";
import {
  Column,
  FooterContainer,
  // FooterGrid,
  LanguageDropdown,
  LanguageSelector,
  LanguageWrapper,
  LinksContainer,
  LogoSection,
  MobileFooterContainer,
  MobileLogoSection,
  MobileLanguageDropdown,
  MobileLanguageSelector,
  MobileLanguageWrapper,
  MobileLinksContainer
} from './style'
import { LazyImage } from 'shared-ui/components'
import { universe } from 'shared-ui/assets'
import { SUPER_APP_FOOTER } from '../../utils/constants'
import { useFreshdeskWidget, useResponsive } from 'shared-ui/hooks'
import Text from '../Text'
import { useTheme } from 'styled-components'
import { FaChevronDown } from 'react-icons/fa'
import { useLanguage } from 'shared-ui/utils/languageProvider'
import { useLanguages } from 'shared-ui/hooks'
import { Divider } from '@mui/material'
import { media } from "shared-ui/utils/media";

const LEGAL_PATHS = ['/privacy.html', '/terms.html']

const prefetchLegalPages = () => {
  if (typeof document === 'undefined') return

  LEGAL_PATHS.forEach((path) => {
    const existing = document.head.querySelector(
      `link[rel="prefetch"][href="${path}"]`
    )

    if (existing) return

    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = path
    link.as = 'document'
    document.head.appendChild(link)
  })
}

const handleLegalNavigate = (event, path) => {
  if (!event || globalThis.window === undefined) return

  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return
  }

  event.preventDefault()

  if (globalThis.location.pathname === path) return

  globalThis.history.pushState({}, '', path)
  globalThis.dispatchEvent(new PopStateEvent('popstate'))
}

const handleCookiePreferences = () => {
  if (globalThis.window === undefined) return

  globalThis.dispatchEvent(new CustomEvent('open-cookie-preferences'))
}

function DesktopFooter({ padding }) {
  const { openWidget } = useFreshdeskWidget()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  const isMobile = useResponsive(media.mobile);

  const { language, toggleLanguage, isLangLoading } = useLanguage()
  const { data: langData } = useLanguages()


  const handleSelect = (langKey) => {
    toggleLanguage(langKey)
    setOpen(false)
  }

  useEffect(() => {
    prefetchLegalPages()

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false)
      }
    }

    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  // const handleSocialClick = (platform) => {
  //   const socialLinks = {
  //     instagram: 'https://www.instagram.com/erosnow/?hl=en#',
  //     facebook: 'https://www.linkedin.com/company/erosinnovation/',
  //     linkedin: 'https://www.linkedin.com/company/erosinnovation/'
  //   };
  //   window.open(socialLinks[platform], '_blank', 'noopener,noreferrer');
  // };

  return (
    <FooterContainer padding={padding}>
      <LogoSection>
        <LazyImage src={universe} width={71} height={28} />
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: '#ffffff', opacity: 0.2 }}
        />
        <Text
          as="span"
          className="company-text"
          fontSize="12px"
          fontWeight={400}
          lineHeight="14px"
          color={theme.app.iconlabel}
          maxLines={2}
        >
          Immerso Innovation
          <br />
          Venture Private Limited
        </Text>
        {/* <div className="social">
          <FaInstagram onClick={() => handleSocialClick('instagram')} />
          <FaFacebookF onClick={() => handleSocialClick('facebook')} />
          <FaLinkedinIn onClick={() => handleSocialClick('linkedin')} />
        </div> */}
      </LogoSection>

      <LinksContainer>
        <a
          href={SUPER_APP_FOOTER[0]?.links[0]?.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {SUPER_APP_FOOTER[0]?.links[0]?.label}
        </a>
        {/* <a href={SUPER_APP_FOOTER[0].links[1].href}>
          {SUPER_APP_FOOTER[0].links[1].label}
        </a>
        <a href={SUPER_APP_FOOTER[0].links[2].href}>
          {SUPER_APP_FOOTER[0].links[2].label}
        </a> */}
        <button type="button" onClick={openWidget} className="footer-link">
          {SUPER_APP_FOOTER[0]?.links[3]?.label}
        </button>

        <a
          href={SUPER_APP_FOOTER[0]?.links[4]?.href}
          onClick={(event) =>
            handleLegalNavigate(event, SUPER_APP_FOOTER[0]?.links[4]?.href)
          }
          onMouseEnter={prefetchLegalPages}
          onTouchStart={prefetchLegalPages}
        >
          {SUPER_APP_FOOTER[0]?.links[4]?.label}
        </a>
        <a
          href={SUPER_APP_FOOTER[0]?.links[5]?.href}
          onClick={(event) =>
            handleLegalNavigate(event, SUPER_APP_FOOTER[0]?.links[5]?.href)
          }
          onMouseEnter={prefetchLegalPages}
          onTouchStart={prefetchLegalPages}
        >
          {SUPER_APP_FOOTER[0]?.links[5]?.label}
        </a>
        <button
          type="button"
          onClick={handleCookiePreferences}
          className="footer-link"
        >
          {SUPER_APP_FOOTER[0]?.links[6]?.label || 'Privacy Preferences'}
        </button>
      </LinksContainer>

      <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
        <LanguageWrapper ref={wrapperRef}>
          <LanguageSelector onClick={() => setOpen(prev => !prev)}>
            <span>
              {
                langData?.data?.find(l => l.key === language)?.alt_display_name
                || 'English'
              }
            </span>
            <FaChevronDown className={open ? 'rotate' : ''} />
          </LanguageSelector>

          {open && (
            <LanguageDropdown>
              {langData?.data?.map((lang) => (
                <div
                  key={lang.key}
                  onClick={() => handleSelect(lang.key)}
                >
                  {lang.alt_display_name}
                </div>
              ))}
            </LanguageDropdown>
          )}
        </LanguageWrapper>


        <Text
          as="h1"
          fontSize="14px"
          fontWeight={400}
          color={theme.colors.MidGray}
        >
          © 2026 Eros Universe by Eros Innovation
        </Text>
      </div>

      {/* <FooterGrid> */}
      {/* <Column>
          <Text as="h1" fontSize={'14px'} fontWeight={600} color={theme.app.iconlabel} marginBottom="18px" >{SUPER_APP_FOOTER[0].title}</Text>
          <a href={SUPER_APP_FOOTER[0].links[0].href}>{SUPER_APP_FOOTER[0].links[0].label}</a>
          <a href={SUPER_APP_FOOTER[0].links[1].href}>{SUPER_APP_FOOTER[0].links[1].label}</a>
          <a href={SUPER_APP_FOOTER[0].links[2].href}>{SUPER_APP_FOOTER[0].links[2].label}</a>
        </Column> */}

      {/* <Column>
        <Text as="h1" fontSize={'14px'} fontWeight={600} color={theme.app.iconlabel} marginBottom="18px" >{SUPER_APP_FOOTER[1].title}</Text>
          <a href={SUPER_APP_FOOTER[1].links[0].href}>{SUPER_APP_FOOTER[1].links[0].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[1].href}>{SUPER_APP_FOOTER[1].links[1].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[2].href}>{SUPER_APP_FOOTER[1].links[2].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[3].href}>{SUPER_APP_FOOTER[1].links[3].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[4].href}>{SUPER_APP_FOOTER[1].links[4].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[5].href}>{SUPER_APP_FOOTER[1].links[5].label}</a>
          <a href={SUPER_APP_FOOTER[1].links[6].href}>{SUPER_APP_FOOTER[1].links[6].label}</a>
        </Column> */}

      {/* <Column>
        <Text as="h1" fontSize={'14px'} fontWeight={600} color={theme.app.iconlabel} marginBottom="18px" >{SUPER_APP_FOOTER[2].title}</Text>
          <a href={SUPER_APP_FOOTER[2].links[0].href}>{SUPER_APP_FOOTER[2].links[0].label}</a>
          <a href={SUPER_APP_FOOTER[2].links[1].href}>{SUPER_APP_FOOTER[2].links[1].label}</a>
          <a href={SUPER_APP_FOOTER[2].links[2].href}>{SUPER_APP_FOOTER[2].links[2].label}</a>
        </Column> */}

      {/* <Column>
        <Text as="h1" fontSize={'14px'} fontWeight={600} color={theme.app.iconlabel} marginBottom="18px" >{SUPER_APP_FOOTER[3].title}</Text>
          <a href={SUPER_APP_FOOTER[3].links[0].href}>{SUPER_APP_FOOTER[3].links[0].label}</a>
          <a href={SUPER_APP_FOOTER[3].links[1].href}>{SUPER_APP_FOOTER[3].links[1].label}</a>
        </Column> */}
      {/* </FooterGrid> */}
    </FooterContainer>
  )
}

function MobileFooter({ height }) {
  const { openWidget } = useFreshdeskWidget()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  const isMobile = useResponsive(media.mobile)

  const { language, toggleLanguage, isLangLoading } = useLanguage()
  const { data: langData } = useLanguages()

  const handleSelect = (langKey) => {
    toggleLanguage(langKey)
    setOpen(false)
  }

  useEffect(() => {
    prefetchLegalPages()

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false)
      }
    }

    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  return (
    <MobileFooterContainer isMobile={isMobile} height={height}>
      <MobileLogoSection className="mb-6">
        <LazyImage src={universe} width={48} height={19} />
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: '#ffffff', opacity: 0.12 }}
        />
        <Text
          as="span"
          className="company-text"
          fontSize="12px"
          fontWeight={400}
          lineHeight="14px"
          color={theme.app.iconlabel}
          maxLines={2}
        >
          Immerso Innovation
          <br />
          Venture Private Limited
        </Text>
      </MobileLogoSection>

      <MobileLinksContainer className="mb-6">
        <Column>
          <a
            href={SUPER_APP_FOOTER[0]?.links[0]?.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {SUPER_APP_FOOTER[0]?.links[0]?.label}
          </a>
         <button type="button" onClick={openWidget} className="footer-link mt-3">
            {SUPER_APP_FOOTER[0]?.links[3]?.label}
          </button>
        </Column>

        <Column>
           <a
            href={SUPER_APP_FOOTER[0]?.links[4]?.href}
            onClick={(event) =>
              handleLegalNavigate(event, SUPER_APP_FOOTER[0]?.links[4]?.href)
            }
            onTouchStart={prefetchLegalPages}
          >
            {SUPER_APP_FOOTER[0]?.links[4]?.label}
          </a>
        
          <a
            href={SUPER_APP_FOOTER[0]?.links[5]?.href}
            onClick={(event) =>
              handleLegalNavigate(event, SUPER_APP_FOOTER[0]?.links[5]?.href)
            }
            onTouchStart={prefetchLegalPages}
            className="my-3"
          >
            {SUPER_APP_FOOTER[0]?.links[5]?.label}
          </a>
          <button
            type="button"
            onClick={handleCookiePreferences}
            className="footer-link"
          >
            {SUPER_APP_FOOTER[0]?.links[6]?.label || 'Privacy Preferences'}
          </button>
        </Column>
      </MobileLinksContainer>

      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', alignItems: 'flex-start' }}>
        <MobileLanguageWrapper ref={wrapperRef} className="mb-4">
          <MobileLanguageSelector onClick={() => setOpen((prev) => !prev)}>
            <span>
              {
                langData?.data?.find((l) => l.key === language)?.alt_display_name ||
                'English'
              }
            </span>
            <FaChevronDown className={open ? 'rotate' : ''} />
          </MobileLanguageSelector>

          {open && (
            <MobileLanguageDropdown>
              {langData?.data?.map((lang) => (
                <div key={lang.key} onClick={() => handleSelect(lang.key)}>
                  {lang.alt_display_name}
                </div>
              ))}
            </MobileLanguageDropdown>
          )}
        </MobileLanguageWrapper>

        <Text as="h1" fontSize="13px" fontWeight={400} color={theme.colors.MidGray}>
          © 2026 Eros Universe by Eros Innovation
        </Text>
      </div>
    </MobileFooterContainer>
  )
}

export default function WrappedSuperAppFooter(props) {
  const isMobile = useResponsive(media.mobile)
  return isMobile ? <MobileFooter {...props} /> : <DesktopFooter {...props} />
}
